import React from 'react';

export default class GoogleTagManager extends React.Component {
  convertToKeyValueString(obj) {
    return JSON.stringify(obj).slice(1, -1);
  }

  render() {
    const script = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-MXK97HQ');
    `;

    return (
      <>
        <script dangerouslySetInnerHTML={{ __html: script }} />
      </>
    );
  }
}
